import { CommunicationsTab_OptimizedV2State } from "@/Communications/Components/CommunicationsTab_OptimizedV2";
import { ExternalMessageInboxState } from "@/Communications/Components/ExternalCommunications/ExternalMessageInboxComponent";
import { BaseExternalMessageFormState } from "@/Communications/Components/ExternalCommunications/Form/BaseExternalMessageFormComponent";
import { MessageTaskEditContainerState } from "@/Communications/Components/MessageTaskEdit/MessageTaskEditContainer";
import { MessageTaskViewContainerState } from "@/Communications/Components/MessageTaskView/MessageTaskViewContainer";
import { RecallEdit_V2State } from "@/Communications/Components/Recalls/RecallEdit_V2";
import { RecallView_V2State } from "@/Communications/Components/Recalls/RecallView_V2";
import { MessageSearch_OptimizedV2State } from "@/Communications/Components/Search/MessageSearch_OptimizedV2";
import { MessageSettingsContainer_OptimizedV2State } from "@/Communications/Components/Search/MessageSearchSettingsContainer_OptimizedV2";
import { RecallSearch_OptimizedV2State } from "@/Communications/Components/Search/RecallSearch_OptimizedV2";
import { RecallSearchSettingsContainer_OptimizedV2State } from "@/Communications/Components/Search/RecallSearchSettingsContainer_OptimizedV2";
import { TaskSearch_OptimizedV2State } from "@/Communications/Components/Search/TaskSearch_OptimizedV2";
import { TaskSettingsContainer_OptimizedV2State } from "@/Communications/Components/Search/TaskSettingsContainer_OptimizedV2";

class CommunicationsStateModel {
    public communicationsTabSavedState: CommunicationsTab_OptimizedV2State;

    public recallSearchSavedState: RecallSearch_OptimizedV2State;
    public recallSettingContainerSavedState: RecallSearchSettingsContainer_OptimizedV2State;

    public messageSearchSavedState: MessageSearch_OptimizedV2State;
    public messageSettingContainerSavedState: MessageSettingsContainer_OptimizedV2State;

    public taskSearchSavedState: TaskSearch_OptimizedV2State;
    public taskSettingContainerSavedState: TaskSettingsContainer_OptimizedV2State;

    public recallEditSavedState: RecallEdit_V2State;
    public recallViewSavedState: RecallView_V2State;

    public messageTaskViewContainerSavedState: MessageTaskViewContainerState;

    public messageTaskEditContainerSavedState: MessageTaskEditContainerState;

    public externalMessageFormState: BaseExternalMessageFormState;
    public externalMessageInboxSearchSettingsState: ExternalMessageInboxState;
}

export { CommunicationsStateModel };
